import { IconInterface } from '../interfaces/icon.interface';

export const ChevronDownIcon = (props: IconInterface) => {
	const {
		color = '#454545',
		width = 10,
		height = 6,
		strokeWidth = '1.6',
	} = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="3 5 10 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4 6l4 4 4-4"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
